import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../page/home/home";
// import {
//   AddBlog,
//   AdminDashboard,
//   Adminlogin,
//   InsightsPage,
//   BlogsDetails,
// } from "../link/link";
import ProtectedRoute from "../page/admin/ProtectedRoute";
import BgLoader from "../Components/bgloader/BgLoader";
import NotFound from "../Components/notfound/NotFound";
import AdminLayout from "../layouts/AdminLayout";
import PublicLayout from "../layouts/PublicLayout";
import Bfsiblog from "../page/Blogs/blogdetails/bfsi_blog/Bfsiblog";

// import HRMSLifeCycle from "../page/Blogs/blogdetails/hrmslifecycle/HRMSLifeCycle";

//! admin routes

const Adminlogin = lazy(() => import("../page/admin/Adminlogin"));

const AdminDashboard = lazy(() => import("../page/admin/AdminDashboard"));

// const AddBlog = lazy(() => import("../page/admin/blog/AddBlog"));

//! core Pages
const Impact = lazy(() => import("../page/Impact/Impact"));
const Hrms = lazy(() => import("../page/HRMS/Hrms"));
// import HrmsOverview from "../page/HRMS/HrmsOverview";
const HrmsOverview = lazy(() => import("../page/HRMS/HrmsOverview"));
const AgentforcePage = lazy(() => import("../page/Agentforce/AgentforcePage"));
const Careers = lazy(() => import("../page/careers/Careers"));
const Opportunities = lazy(() => import("../page/careers/Opportunities"));
const JobDetails = lazy(() => import("../page/careers/JobDetails"));
const Aboutus = lazy(() => import("../page/aboutus/Aboutus"));
const Contactus = lazy(() => import("../page/contactus/Contactus"));
const Contactform = lazy(() => import("../page/contactus/Contactforms"));
const Termsandconditions = lazy(
  () => import("../page/terms&conditions/Termsandconditions"),
);
const Privacypolicy = lazy(() => import("../page/privacypolicy/Privacypolicy"));
const LifeAtUtil = lazy(() => import("../page/lifeatutil/LifeAtUtil"));
const Partnerwithus = lazy(() => import("../page/partnerwithus/Partnerwithus"));

//! Solutions
const SocialListening = lazy(() => import("../page/solutions/SocialListening"));
const Utilia = lazy(() => import("../page/solutions/Utilia"));
const FieldVisit = lazy(() => import("../page/solutions/FieldVisit"));

//! Industries
const Edtech = lazy(() => import("../page/industries/education/edtech/Edtech"));
const PreSchool = lazy(
  () => import("../page/industries/education/preschool/PreSchool"),
);
const HigherEducation = lazy(
  () => import("../page/industries/education/higherEducation/HigherEducation"),
);
const StafffingAgencies = lazy(
  () =>
    import("../page/industries/recruitment&Staffing/staffingAgencies/StafffingAgencies"),
);
const HealthCareAndPharma = lazy(
  () =>
    import("../page/industries/healthcare/healthcare&Pharma/HealthCareAndPharma"),
);
const AutomobileComponents = lazy(
  () =>
    import("../page/industries/automotive/automobile_components/AutomobileComponents"),
);
const AutomobileOEM = lazy(
  () => import("../page/industries/automotive/automobile_oem/AutomobileOEM"),
);
const HotelsAndTourism = lazy(
  () =>
    import("../page/industries/tourismAndHospitality/hotels&tourism/HotelsAndTourism"),
);
const LogisticsAndTransport = lazy(
  () =>
    import("../page/industries/tourismAndHospitality/logisticsAndtransport/LogisticsAndTransport"),
);
const RealEstate = lazy(
  () => import("../page/industries/realEstate/RealEstate"),
);
const NGOs = lazy(() => import("../page/industries/nonprofit/NGOs/NGOs"));
const EducationalNonProfits = lazy(
  () =>
    import("../page/industries/nonprofit/educational_NonProfits/EducationalNonProfits"),
);
const Bfsi = lazy(() => import("../page/industries/banking&finance/BFSI/Bfsi"));
const Fintech = lazy(
  () => import("../page/industries/banking&finance/fintech/Fintech"),
);
const WealthManagement = lazy(
  () =>
    import("../page/industries/banking&finance/wealthmanagement/WealthManagement"),
);
const RCG = lazy(() => import("../page/industries/manufacturing/RCG/RCG"));
const Coremanufacturing = lazy(
  () =>
    import("../page/industries/manufacturing/Coremanufacturing/Coremanufacturing"),
);

//! Services
const Salesforceconsulting = lazy(
  () =>
    import("../page/services/mainservices/salesforceconsulting/Salesforceconsulting"),
);
const Salescloud = lazy(
  () =>
    import("../page/services/mainservices/implementationanddeployment/segments/sales_cloud/Salescloud"),
);
const ServiceCloud = lazy(
  () =>
    import("../page/services/mainservices/implementationanddeployment/segments/service_cloud/ServiceCloud"),
);
const MarketingCloud = lazy(
  () =>
    import("../page/services/mainservices/implementationanddeployment/segments/marketing_cloud/MarketingCloud"),
);
const CommunityCloud = lazy(
  () =>
    import("../page/services/mainservices/implementationanddeployment/segments/community_cloud/CommunityCloud"),
);
const Dmsimplimentation = lazy(
  () =>
    import("../page/services/mainservices/implementationanddeployment/segments/Dmsimplementation/Dmsimplimentation"),
);
const Industrycloud = lazy(
  () =>
    import("../page/services/mainservices/implementationanddeployment/segments/Industrycloud/Industrycloud"),
);
const Commercecloud = lazy(
  () =>
    import("../page/services/mainservices/implementationanddeployment/segments/commerce_cloud/Commercecloud"),
);
const Einstein = lazy(
  () =>
    import("../page/services/mainservices/implementationanddeployment/segments/Einstein_ai/Einstein"),
);

const IntegrationServices = lazy(
  () =>
    import("../page/services/mainservices/custom_development/integration_services/IntegrationServices"),
);
const DataMigration = lazy(
  () =>
    import("../page/services/mainservices/custom_development/DataMigration/DataMigration"),
);
const DevOpsAndCICD = lazy(
  () =>
    import("../page/services/mainservices/custom_development/DevOpsAndCICD/DevOpsAndCICD"),
);
const TestingAndQA = lazy(
  () =>
    import("../page/services/mainservices/custom_development/testingAndQA/TestingAndQA"),
);
const TrainingAndUserAdaptation = lazy(
  () =>
    import("../page/services/mainservices/trainingAndUserAdaptaion/TrainingAndUserAdaptation"),
);
const OrgAssessment = lazy(
  () => import("../page/services/mainservices/OrgAssessment/OrgAssessment"),
);
const ManagedServices = lazy(
  () =>
    import("../page/services/mainservices/managed_services/managed_services_support/ManagedServices"),
);
const SupportModels = lazy(
  () =>
    import("../page/services/mainservices/managed_services/SupportModels/SupportModels"),
);

const LightningMigration = lazy(
  () =>
    import("../page/services/mainservices/custom_development/LightningMigration/LightningMigration"),
);

//! Products
const AgentForce = lazy(
  () => import("../page/products/agent_force/AgentForce"),
);
const FieldService = lazy(
  () => import("../page/products/field_service/FieldService"),
);
const DMSAndMobileApp = lazy(
  () => import("../page/products/DMSandMobileApp/DMSAndMobileApp"),
);
const Marketingcloud = lazy(
  () => import("../page/products/marketingcloud/Marketingcloud"),
);
const Cpq = lazy(() => import("../page/products/cpq/Cpq"));
const SalesCloud = lazy(
  () => import("../page/products/sales_cloud/SalesCloud"),
);
const ServiceCloudProduct = lazy(
  () => import("../page/products/service_cloud/ServiceCloudProduct"),
);
const CommerceCloud = lazy(
  () => import("../page/products/commerce_cloud/CommerceCloud"),
);
const DataCloud = lazy(() => import("../page/products/data_cloud/DataCloud"));
const Nonprofit = lazy(() => import("../page/products/nonprofit/Nonprofit"));
const Crmanalytics = lazy(
  () => import("../page/products/crmanalytics/Crmanalytics"),
);
const Heroko = lazy(() => import("../page/products/heroko/Heroko"));

//! Components / misc routes
const TotalCards = lazy(() => import("../page/Impact/TotalCards"));
const Cookies = lazy(() => import("../Components/cookies/Cookies"));
const Certificates = lazy(
  () => import("../templates/home/certificates/Certificates"),
);
const Applyforms = lazy(() => import("../Components/forms/Applyforms"));
const Talktoanexpert = lazy(
  () => import("../Components/Talkto expert/Talktoanexpert"),
);
const Certifications = lazy(
  () => import("../Components/certifications/Certifications"),
);

//! blog pages
const DigitalDisruption = lazy(
  () => import("../page/Blogs/blogdetails/digitaldisruption/DigitalDisruption"),
);
const UnlockAgentForce = lazy(
  () => import("../page/Blogs/blogdetails/unlockagentforce/UnlockAgentForce"),
);
const HRMSLifeCycle = lazy(
  () => import("../page/Blogs/blogdetails/hrmslifecycle/HRMSLifeCycle"),
);
const AI_Transforming = lazy(
  () => import("../page/Blogs/blogdetails/Ai_Transform/AI_Transforming"),
);
const BetterCare = lazy(
  () => import("../page/Blogs/blogdetails/better_care/BetterCare"),
);

// import TableauBlog from "../page/Blogs/blogdetails/tableau/TableauBlog";
const TableauBlog = lazy(
  () => import("../page/Blogs/blogdetails/tableau/TableauBlog"),
);
const AgenticManufacturing = lazy(
  () =>
    import(
      "../page/Blogs/blogdetails/AgenticManufacturing/AgenticManufacturing"
    ),
);
const SalesforceNvidiaKoa = lazy(
  () =>
    import(
      "../page/Blogs/blogdetails/SalesforceNvidiaKoa/SalesforceNvidiaKoa"
    ),
);

const BlogsDetails = lazy(() => import("../page/Blogs/BlogsDetails"));
// const InsightsPage = lazy(() => import("../page/Blogs/InsightsPage"));

const RootRouter = () => {
  // const jobTitle = (useSelector((state) => state.career.job_title) || "")
  //   .toLowerCase()
  //   .replace(/\s+/g, "");

  // const { blogs, loading } = useSelector((state) => state.blog);

  return (
    <Suspense fallback={<BgLoader />}>
      <Routes>
        {/* admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Adminlogin />} />
          <Route path="login" element={<Adminlogin />} />
          <Route
            path="dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          {/* <Route
          path="/add-blog"
          element={
            <ProtectedRoute>
              <AddBlog />
            </ProtectedRoute>
          }
        /> */}
        </Route>
        {/* public Routes */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/hrms" element={<Hrms />} />
          <Route path="/hrms/hrms-overview" element={<HrmsOverview />} />
          <Route path="/agentforce" element={<AgentforcePage />} />
          <Route path="/aboutus/our-impact" element={<Impact />} />
          <Route
            path="/aboutus/blogs/digital-disruption"
            element={<DigitalDisruption />}
          />
          <Route
            path="/aboutus/blogs/unlocking-agentforce"
            element={<UnlockAgentForce />}
          />
          <Route
            path="/aboutus/blogs/hrmslifecycle"
            element={<HRMSLifeCycle />}
          />
          <Route
            path="/aboutus/blogs/ai-transforming-crm"
            element={<AI_Transforming />}
          />
          <Route path="/aboutus/blogs/better-care" element={<BetterCare />} />

          <Route path="/aboutus/blogs/tableau" element={<TableauBlog />} />
          <Route path="/aboutus/blogs/bfsi" element={<Bfsiblog />} />
          <Route
            path="/aboutus/blogs/agentic-ai-manufacturing"
            element={<AgenticManufacturing />}
          />
          <Route
            path="/aboutus/blogs/salesforce-nvidia-koa"
            element={<SalesforceNvidiaKoa />}
          />
          {/* <Route path="/insight-blog" element={<InsightsPage />} /> */}
          <Route
            path="/aboutus/our-impact/blog-details/:id"
            element={<BlogsDetails />}
          />
          <Route path="/careers" element={<Careers />} />
          <Route path="/careers/opportunities" element={<Opportunities />} />
          <Route
            path="/careers/opportunities/jobdetails/:slug"
            element={<JobDetails />}
          />

          {/* Company */}
          <Route path="/aboutus/our-story" element={<Aboutus />} />
          {/* <Route path="/products" element={null} /> */}
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/aboutus/life-at-util" element={<LifeAtUtil />} />

          <Route path="/termsandconditions" element={<Termsandconditions />} />

          <Route path="/aboutus/partnerwithus" element={<Partnerwithus />} />
          <Route path="/privacypolicy" element={<Privacypolicy />} />
          <Route path="/contactform" element={<Contactform />} />
          <Route path="/talktoexpert" element={<Talktoanexpert />} />

          {/* Solutions */}
          <Route
            path="/solutions/social_listening"
            element={<SocialListening />}
          />
          <Route path="/solutions/utilia" element={<Utilia />} />
          <Route path="/solutions/field_visit" element={<FieldVisit />} />

          {/* Industry */}
          <Route path="/industry/banking-finance/bfsi" element={<Bfsi />} />
          <Route
            path="/industry/banking-finance/fintech"
            element={<Fintech />}
          />
          <Route
            path="/industry/banking-finance/wealth-management"
            element={<WealthManagement />}
          />
          <Route path="/industry/education/edtech" element={<Edtech />} />
          <Route
            path="/industry/education/preschools-k12"
            element={<PreSchool />}
          />
          <Route
            path="/industry/education/higher-education"
            element={<HigherEducation />}
          />
          <Route
            path="/industry/recruitment&staffing/staffing-agencies"
            element={<StafffingAgencies />}
          />
          <Route path="/industry/manufacturing/rcg" element={<RCG />} />
          <Route
            path="/industry/manufacturing/coremanufacturing"
            element={<Coremanufacturing />}
          />
          <Route
            path="/industry/healthcare&pharma/healthcare-pharma"
            element={<HealthCareAndPharma />}
          />
          <Route
            path="/industry/automobile/automobile-oem"
            element={<AutomobileOEM />}
          />
          <Route
            path="/industry/automobile/automobile-components"
            element={<AutomobileComponents />}
          />
          <Route
            path="/industry/tourism&hospitality/hotels-tourism"
            element={<HotelsAndTourism />}
          />
          <Route
            path="/industry/tourism&hospitality/logistics-transport"
            element={<LogisticsAndTransport />}
          />
          <Route path="/industry/real-estate" element={<RealEstate />} />
          <Route path="/industry/non-profit/ngos" element={<NGOs />} />
          <Route
            path="/industry/non-profit/educational-non-profits"
            element={<EducationalNonProfits />}
          />

          {/* Services */}
          <Route
            path="/services/salesforce-consulting"
            element={<Salesforceconsulting />}
          />
          <Route
            path="/services/implementation/sales-cloud"
            element={<Salescloud />}
          />
          <Route
            path="/services/implementation/service-cloud"
            element={<ServiceCloud />}
          />
          <Route
            path="/services/implementation/marketing-cloud"
            element={<MarketingCloud />}
          />
          <Route
            path="/services/implementation/experience-cloud"
            element={<CommunityCloud />}
          />

          <Route
            path="/services/implementation/dms"
            element={<Dmsimplimentation />}
          />

          <Route
            path="/services/custom-development/integration-services"
            element={<IntegrationServices />}
          />

          <Route
            path="/services/custom-development/data-migration-management"
            element={<DataMigration />}
          />

          <Route
            path="/services/custom-development/salesforce-devops-cicd"
            element={<DevOpsAndCICD />}
          />

          <Route
            path="/services/custom-development/lightning-migration"
            element={<LightningMigration />}
          />

          <Route
            path="/services/custom-development/testing-qa-services"
            element={<TestingAndQA />}
          />

          <Route
            path="/services/implementation/industry-clouds"
            element={<Industrycloud />}
          />
          <Route
            path="/services/implementation/commerce-cloud"
            element={<Commercecloud />}
          />
          <Route
            path="/services/implementation/ai-einstein"
            element={<Einstein />}
          />

          <Route
            path="/services/training-user-adoption"
            element={<TrainingAndUserAdaptation />}
          />

          <Route
            path="/services/salesforce-org-assessment"
            element={<OrgAssessment />}
          />
          <Route
            path="/services/managed-services/managed-services-support"
            element={<ManagedServices />}
          />
          <Route
            path="/services/managed-services/support-models"
            element={<SupportModels />}
          />

          <Route path="/totalcards" element={<TotalCards />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/certifications" element={<Certificates />} />

          {/* produts Routes */}

          <Route
            path="/products/salesforce-agent-force"
            element={<AgentForce />}
          />
          <Route
            path="/products/field-service-lightning"
            element={<FieldService />}
          />
          <Route
            path="/products/dms-mobile-app"
            element={<DMSAndMobileApp />}
          />

          <Route path="/products/marketingcloud" element={<Marketingcloud />} />
          <Route path="/products/cpq" element={<Cpq />} />

          <Route path="/products/sales-cloud" element={<SalesCloud />} />
          <Route
            path="/products/service-cloud"
            element={<ServiceCloudProduct />}
          />
          <Route path="/products/commerce-cloud" element={<CommerceCloud />} />
          <Route path="/products/data-cloud" element={<DataCloud />} />
          <Route path="/products/nonprofit" element={<Nonprofit />} />

          <Route path="/products/crmanalytics" element={<Crmanalytics />} />
          <Route path="/products/heroku" element={<Heroko />} />
        </Route>
        //! not found invalid url
        <Route path="*" element={<NotFound />} />
        <Route path="/404-error-page" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default RootRouter;
